export enum StatusCodeResponse {
  SUCCESS = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  SYSTEM_ERROR = 500,
}
